// extracted by mini-css-extract-plugin
export var details = "_ip-0";
export var inspectorPopover = "_ip-1";